/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { UpdateITLeasingSettingsDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * ITLeasingApi - axios parameter creator
 * @export
 */
export const ITLeasingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary update the it leasing company link of a tenant
         * @param {string} tenantId 
         * @param {UpdateITLeasingSettingsDTO} updateITLeasingSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateITLeasingSettings: async (tenantId: string, updateITLeasingSettingsDTO: UpdateITLeasingSettingsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateITLeasingSettings', 'tenantId', tenantId)
            // verify required parameter 'updateITLeasingSettingsDTO' is not null or undefined
            assertParamExists('updateITLeasingSettings', 'updateITLeasingSettingsDTO', updateITLeasingSettingsDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/it_leasing/settings`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateITLeasingSettingsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ITLeasingApi - functional programming interface
 * @export
 */
export const ITLeasingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ITLeasingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary update the it leasing company link of a tenant
         * @param {string} tenantId 
         * @param {UpdateITLeasingSettingsDTO} updateITLeasingSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateITLeasingSettings(tenantId: string, updateITLeasingSettingsDTO: UpdateITLeasingSettingsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateITLeasingSettings(tenantId, updateITLeasingSettingsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ITLeasingApi - factory interface
 * @export
 */
export const ITLeasingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ITLeasingApiFp(configuration)
    return {
        /**
         * 
         * @summary update the it leasing company link of a tenant
         * @param {string} tenantId 
         * @param {UpdateITLeasingSettingsDTO} updateITLeasingSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateITLeasingSettings(tenantId: string, updateITLeasingSettingsDTO: UpdateITLeasingSettingsDTO, options?: any): AxiosPromise<void> {
            return localVarFp.updateITLeasingSettings(tenantId, updateITLeasingSettingsDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateITLeasingSettings operation in ITLeasingApi.
 * @export
 * @interface ITLeasingApiUpdateITLeasingSettingsRequest
 */
export interface ITLeasingApiUpdateITLeasingSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof ITLeasingApiUpdateITLeasingSettings
     */
    readonly tenantId: string

    /**
     * 
     * @type {UpdateITLeasingSettingsDTO}
     * @memberof ITLeasingApiUpdateITLeasingSettings
     */
    readonly updateITLeasingSettingsDTO: UpdateITLeasingSettingsDTO
}

/**
 * ITLeasingApi - object-oriented interface
 * @export
 * @class ITLeasingApi
 * @extends {BaseAPI}
 */
export class ITLeasingApi extends BaseAPI {
    /**
     * 
     * @summary update the it leasing company link of a tenant
     * @param {ITLeasingApiUpdateITLeasingSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ITLeasingApi
     */
    public updateITLeasingSettings(requestParameters: ITLeasingApiUpdateITLeasingSettingsRequest, options?: AxiosRequestConfig) {
        return ITLeasingApiFp(this.configuration).updateITLeasingSettings(requestParameters.tenantId, requestParameters.updateITLeasingSettingsDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
